import { useQuery } from "react-query";
import { getTargetSystem } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

let targetSystemList = [];
export const useGetActiveTargetSystem = () => {
  useQuery("TargetSystem", getTargetSystem, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      if (res) {
        if (res.statusCode === 500 || res.statusCode === 400) {
        } else {
          targetSystemList = [];
          res.map((target) => {
            if (target.isActive === true) {
              targetSystemList.push({
                label: target.targetSystemName,
                value: target.targetSystemId,
              });
            }
          });
        }
      }
    },
  });

  return targetSystemList;
};
